export default {
  name: 'timedTaskManagement',
  data () {
    return {
      labelPosition: 'right',
      page: {
        num: 1,
        size: 10
      },
      totalRows: 100,
      formInline: {
        taskName: '',
        sysId: '',
        status: ''
      },
      tooltip: true,
      statusData: [
        {
          id: 1,
          value: '启用'
        },
        {
          id: 0,
          value: '禁用'
        }
      ],
      tableList: [],
      dialogFormVisible: false,
      dialogTitle: {
        addTask: '新增定时任务',
        editTask: '编辑定时任务'
      },
      dialogStatus: '',
      taskForm: {
        taskId: '',
        sysId: '',
        taskName: '',
        taskGroupName: '',
        taskUrl: '',
        taskParam: '',
        cronExp: '',
        status: 1,
        description: ''
      },
      rules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        taskGroupName: [
          { required: true, message: '请输入任务组名', trigger: 'blur' }
        ],
        taskUrl: [
          { required: true, message: '请输入调用地址', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                /* 密码包含大小写字母，数字,特殊字符至少三种 */
                if (
                  /^(https|http|ftp|rtsp|mms):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/.test(
                    value
                  ) == false
                ) {
                  callback(
                    new Error(
                      '请输入正确的地址，如：http://192.168.1.1:8080/test'
                    )
                  )
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        cronExp: [
          { required: true, message: '请输入执行表达式', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    this.queryList()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 表格状态值转换 */
    taskStatus (row) {
      if (row.status == '1') {
        return '启用'
      } else if (row.status == '0') {
        return '禁用'
      }
    },
    /* 查询列表 */
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size,
        sysIds: sysIds,
        status: this.formInline.status,
        taskName: this.formInline.taskName
      }
      let _self = this
      this.$axios
        .post(this.$API.tasksched.queryTaskList, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    /* 更改任务状态 禁用/启用 */
    changeStatus (index, value) {
      if (value.status == 1) {
        value.status = 0
        let params = {
          taskId: value.taskId,
          status: 1
        }
        this.$confirm('是否修改定时任务状态为启用?', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.tasksched.changeTaskStatus, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '启用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.status = 1
        let params = {
          taskId: value.taskId,
          status: 0
        }
        this.$confirm('是否修改定时任务状态为禁用?', '禁用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.tasksched.changeTaskStatus, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '禁用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    /* 新增 */
    addTask () {
      this.dialogFormVisible = true
      this.dialogStatus = 'addTask'
    },
    /* 编辑 */
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.dialogStatus = 'editTask'
      this.taskForm.taskId = row.taskId
      this.taskForm.sysId = Number(row.sysId)
      this.taskForm.taskName = row.taskName
      this.taskForm.taskGroupName = row.taskGroupName
      this.taskForm.taskUrl = row.taskUrl
      this.taskForm.taskParam = row.taskParam
      this.taskForm.cronExp = row.cronExp
      this.taskForm.status = row.status
      this.taskForm.description = row.description
    },
    /* 根据状态保存新增/编辑定时任务 */
    saveTask (formName) {
      if (this.dialogStatus == 'editTask') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.taskForm.sysId) {
              sysIds.push(this.taskForm.sysId)
            }
            let params = {
              cronExp: this.taskForm.cronExp,
              description: this.taskForm.description,
              status: this.taskForm.status,
              sysIds: sysIds,
              taskGroupName: this.taskForm.taskGroupName,
              taskId: this.taskForm.taskId,
              taskName: this.taskForm.taskName,
              taskParam: this.taskForm.taskParam,
              taskUrl: this.taskForm.taskUrl
            }
            this.$axios
              .post(this.$API.tasksched.edit, params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      } else if (this.dialogStatus == 'addTask') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.taskForm.sysId) {
              sysIds.push(this.taskForm.sysId)
            }
            let params = {
              cronExp: this.taskForm.cronExp,
              description: this.taskForm.description,
              status: this.taskForm.status,
              sysIds: sysIds,
              taskGroupName: this.taskForm.taskGroupName,
              taskName: this.taskForm.taskName,
              taskParam: this.taskForm.taskParam,
              taskUrl: this.taskForm.taskUrl
            }
            this.$axios
              .post(this.$API.tasksched.create, params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      }
    },
    /* 关闭弹窗 */
    closeDialog (formName) {
      this.dialogFormVisible = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.taskForm.taskName = ''
      this.taskForm.taskGroupName = ''
      this.taskForm.taskUrl = ''
      this.taskForm.sysId = ''
      this.taskForm.taskParam = ''
      this.taskForm.cronExp = ''
      this.taskForm.status = 1
      this.taskForm.description = ''
    },
    /* 删除 */
    handleDelete (index, row) {
      let params = {
        taskId: row.taskId
      }
      this.$confirm('确认是否删除此定时任务?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .post(this.$API.tasksched.del, params)
            .then(function (r) {
              _self.dialogFormVisible = false
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.size = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/timedTask/timedTaskManagement.js